<template>
  <span class="renderer text-mono">
    <strong class="profiles" v-if="!!object.rmProceduresCount">
      {{ object.rmProceduresCount }}
    </strong>
    <span v-else class="text-secondary">0</span>
  </span>
</template>

<script>
  export default {
    name: 'ProceduresTableRenderer',
    props: ['object'],
  }
</script>

<style lang="scss" scoped>

</style>
